/* ==========================================================================
   lbl-coffee-reveal — IntersectionObserver-Reveal für animierte Bänder
   (Aromaventil, Klebstoff-Tipp). Setzt .in-view auf [data-lbl-reveal].
   prefers-reduced-motion: sofort sichtbar, keine Animation.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var els = document.querySelectorAll('[data-lbl-reveal]');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      // Inhalt direkt zeigen, ohne Bewegung
      Array.prototype.forEach.call(els, function (el) { el.classList.add('in-view'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('in-view');
      });
    }, { threshold: 0.25 });

    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
